import Task from './index'
import TaskData from './components/taskData/taskData.vue'
import TaskDataUpload from './components/taskDataUpload/taskDataUpload.vue'
export default [
  {
    path: '/tasks',
    component: Task
  },
  {
    path: '/tasks/entry',
    name: '/tasks/entry',
    component: TaskData,
    props: (route) => ({
      taskId: route.query.id,
      mode: route.params.mode
    })
  },
  {
    path: '/tasks/upload',
    name: '/tasks/upload',
    component: TaskDataUpload,
  }
]
